<form class="form-wrap" [formGroup]="settingForm" tabindex="-1" #formElement>
  <dgx-setting-tile-header
    [description]="settingDescription"
    [name]="settingName"
    [enabled]="settingEnabled"
    (toggled)="handleSettingToggled($event)"
  ></dgx-setting-tile-header>
  <div *ngIf="settingEnabled" class="guts-p-t-1-half">
    <div class="grid grid--bleed">
      <div
        *ngFor="let field of formFields"
        class="grid__col-sm-5 m-guts-p-t-1 guts-m-r-2 m-guts-m-r-0"
        data-dgat="setting-tile-toggle-json-04b"
      >
        <label for="setting_{{ field.Key }}">{{
          'OrgSettings_OrgSupportInfo' + field.Key + '_Label' | translate
        }}</label>
        <input
          type="text"
          id="setting_{{ field.Key }}"
          [formControlName]="field.Key"
          data-dgat="setting-tile-toggle-json-f78"
          placeholder="{{
            'OrgSettings_OrgSupportInfo' + field.Key + '_Placeholder'
              | translate
          }}"
          [class.border--error]="
            this.settingForm.controls[field.Key].errors &&
            this.settingForm.controls[field.Key].dirty
          "
        />
        <dgx-setting-tile-validation-message
          [errors]="this.settingForm.controls[field.Key].errors"
          [controlIsDirty]="this.settingForm.controls[field.Key].dirty"
        ></dgx-setting-tile-validation-message>
      </div>
    </div>
    <dgx-setting-tile-save-footer
      [isFormValid]="settingForm.valid"
      (saved)="handleSave()"
      (cancelled)="handleCancel()"
      *ngIf="settingForm.dirty"
    ></dgx-setting-tile-save-footer>
  </div>
</form>
